import { EMPTY_OBJECT } from '../../../constants/common'
import { MessageTemplateSelect } from '../../MessageTemplate'

import { toChatroomTemplateSelectItems } from './ChatroomInputTemplateSelect.utils'
import { ChatroomInputTemplateSelectDropdownListItem } from './ChatroomInputTemplateSelectDropdownListItem'

function ChatroomInputTemplateSelect({
  listProps: {
    Item = ChatroomInputTemplateSelectDropdownListItem,
    ...listProps
  } = EMPTY_OBJECT,
  toPreparedItems = toChatroomTemplateSelectItems,
  ...restProps
}) {
  return (
    <MessageTemplateSelect
      {...restProps}
      listProps={{ Item, ...listProps }}
      toPreparedItems={toPreparedItems}
    />
  )
}

export default ChatroomInputTemplateSelect
